import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { VendorDeviceBillOption } from './types';
import { normalizeVendorDeviceBillItems } from './utils';

const billModelBillItemsResolveUrl = (billModelId: string) =>
  `${PREFIX.vapis_dc(GROUPS.ophub)}/bill-models/${billModelId}/bill-items/resolve`;

/** 按计费模型 + 交付类型 + 资源 code 解析厂商设备计费项列表 */
export async function fetchVendorDeviceBillOptions(
  billModelId: string,
  resourceCode: string,
  deploymentTypeId?: string,
): Promise<VendorDeviceBillOption[]> {
  if (!billModelId || !resourceCode || !deploymentTypeId) return [];

  const res = await get<unknown>(billModelBillItemsResolveUrl(billModelId), {
    resourceCode,
    deploymentTypeId,
  });

  return normalizeVendorDeviceBillItems(res, resourceCode);
}
